import { Trash2 } from 'lucide-react'
import { useT, useLang } from '../../i18n/useT'
import { getConversationPreview, formatConvDate } from './conversations'

export default function ChatHistory({ conversations, activeId, onSelect, onNew, onDelete }) {
  const t    = useT()
  const lang = useLang()

  return (
    <div className="chat-history">
      <button className="chat-history-new" onClick={onNew}>
        + {t('agent_new_conversation')}
      </button>
      {conversations.map(conv => (
        <div
          key={conv.id}
          className={`chat-history-item${conv.id === activeId ? ' active' : ''}`}
          onClick={() => onSelect(conv.id)}
        >
          <div className="chat-history-preview">
            {getConversationPreview(conv, t('agent_empty_conversation'))}
          </div>
          <div className="chat-history-meta">
            <span>{formatConvDate(conv.updated_at, lang)}</span>
            <button
              className="btn-icon btn-icon--sm"
              onClick={(e) => { e.stopPropagation(); onDelete(conv.id) }}
              aria-label={t('delete')}
            >
              <Trash2 size={14} />
            </button>
          </div>
        </div>
      ))}
      {conversations.length === 0 && (
        <div className="chat-history-empty">{t('agent_no_history')}</div>
      )}
    </div>
  )
}
